export const validateInspectionInfo = ({
  formData,
  selectedInspectorId,
  setStepErrors,
}) => {
  let errors = {};

  if (!formData.verificationType) {
    errors.verificationType = true;
  }

  if (!selectedInspectorId) {
    errors.inspector = true;
  }

  if (!formData.manualRef) {
    errors.manualRef = true;
  }

  if (!formData.description) {
    errors.description = true;
  }

  if (!formData.date) {
    errors.date = true;
  }

  if (!formData.testInstrument) {
    errors.testInstrument = true;
  }

  if (!formData.clientName) {
    errors.clientName = true;
  }

  if (!formData.installationAddress) {
    errors.installationAddress = true;
  }

  if (!formData.location) {
    errors.location = true;
  }

  if (!formData.circuitTested) {
    errors.circuitTested = true;
  }

  setStepErrors(errors);

  return Object.keys(errors).length === 0;
};

export const validatePVA = ({
  selectedPanel,
  invertersList,
  setStepErrors,
}) => {
  let errors = {};
  if (!selectedPanel) {
    errors.selectedPanel = true;
  }

  if (invertersList.length <= 0) {
    errors.inverter = true;
  } else {
    invertersList.map((inv) => {
      if (!inv.serialNo.trim()) {
        errors.serialNo = true;
      }
      return true
    });
  }

  setStepErrors(errors);

  return Object.keys(errors).length === 0;
};
